import { 
    CREATE_PROFILE_REQUEST,
    CREATE_PROFILE_SUCCESS,
    CREATE_PROFILE_FAIL,
    GET_USER_PROFILE_REQUEST,
    GET_USER_PROFILE_SUCCESS,
    GET_USER_PROFILE_FAIL,
} from "constants/contributorConstants";

const initialState = {
    loading: false,
}

function createContributorProfileReducer(state = initialState, action) {
    switch (action.type) {
        case CREATE_PROFILE_REQUEST:
            return { ...state, loading: true };
        case CREATE_PROFILE_SUCCESS:
            return { ...state, loading: false};
        case CREATE_PROFILE_FAIL:
            return { ...state, loading: false };
        default: return state;
    }
}

function getContributorProfileReducer(state = initialState, action) {
    switch (action.type) {
        case GET_USER_PROFILE_REQUEST:
            return { ...state, loading: true };
        case GET_USER_PROFILE_SUCCESS:
            return { ...state, loading: false, userProfile: action.payload};
        case GET_USER_PROFILE_FAIL:
            return { ...state, loading: false };
        default: return state;
    }
}

export {
    createContributorProfileReducer,
    getContributorProfileReducer
}